export default {
  menus: {
    index: "首页",
    Customer: "客户",
    Order: "订单",
    OrderStatus: "订单状态",
    Report: "报表",
    ExportDeliveryReport:"客户交期跟踪报表",
    InventoryReport:'库存报表',
    SalesReports:'销售报表',
    FinanceReports:'财务报表',
    LeaderboardReport:'排行榜',
    ExReservationInvitationSummaryForBusiness:'展会邀约汇总表',
    ExReservationTabs:'展会邀约客户明细表',
    ReportOne: "销售净额分析表",
    ReportTwo: "应收账款逾期账龄分析表",
    ReportThree: "接单出货订单表",
    ReportFour: "船务异常费用",
    ReportFive: "出口在库完工柜报表",
    ReportSix: "客户销售汇总排名",
    ReportSeven: "销售颜色汇总排名",
    ReportEight: "款式销售汇总排名",
    ReportNine: "销售明细表",
    ReportTen: "业务接单情况表",
    ReportTwentyV2:"客户摆品及竞品情况",
    vpsalesMezzanine:'竞品客户汇总表',
    newCompetions:'竞品',
    CompetitiveProductAnalysisDataList:"竞品客户明细表",
    ReportEleven: "业务出货及收入情况表",
    ReportTwenty: "客户摆品及竞品情况",
    qsInventory:"QS库存订单报表",
    relatingPrices:"价格",
    Travel: "出差",
    competitors: "竞品",
    competingGoods: "报价单",
    exhibition: "展会",
    Commitments: "展会列表",
    tableListbyCustomer: "意向列表",
    tableList: "展会接单情况表",
    TotalCommitments: "款式总结",
    Video: "视频",
    Documents: "文档",
    Catalog: "文档",
    achievement: "业绩",
    resetPassword: "重置密码",
    Performance: "业绩分析",
    others: "其他",
    DFSEDIInvolce: "DFS EDI 发票",
    lmageVideo: "图片和视频",
    Cover: "面料",
    CoverFeature: "面料特性",
    Admin: "管理员",
    Frames: "产品相关",
    CoversRelated: "颜色相关",
    ContentRelated: "图片相关",
    Models: "款式列表",
    modelsManager: "款式",
    Arms: "扶手",
    Backs: "靠背",
    Categories: "类别",
    Features: "产品特点",
    Mechanisms: "功能铁架",
    Seats: "座包",
    SKU: "规格",
    Styles: "产品风格",
    Arrangements: "组合",
    Covers: "颜色",
    CoversGrades: "颜色等级",
    CoversGroups: "颜色组",
    Photos: "图片",
    Videos: "视频",
    Price: "价格",
    InventoryPlatform: "库存平台",
    InventoryPlatformProductInfoConfig: "产品信息配置",
    InventoryPlatformCustomerData: "客户数据",
    InventoryPlatformSharingReport: "共享报表",
    // InventoryReport: "业务接单情况表",
    RevenueReport: "业务出货及收入情况表",
    InventoryPlatformCustomerDataNew: "客户数据",
    NewStyleMaintenance: "新款维护",
    ExhibitionBonusDistribution: "展会奖金分配",
    ExhibitionBonusStyles: "展会奖金款式",
    SpecificationRelationship: "规格关系",
    FollowUpSituationTable: "展会订单跟进情况表",
    ConfirmOrderDetails: "展会确认订单明细表",
    MarketNewModelBonusReport: "展会奖金报表",
    NewModelRelated: "新款相关",
    ExReservation: "展会预约",
    CustomerManagement: "客户管理",
    CustomerSalesInfo: "客户信息管理",
    cart: "选购清单",
    poList: "PO清单",
    OrderAverageDeliveryTime: "客户平均货期",
    OrderDeliveryTimeOverview: '货期概览',
    OrderDeliveryTimeDetail: '货期详情',
    CompetitiveProductAnalysis:'客户竞品',
    newCP:'公司竞品',
    OrderIntake: '接单情况',
    ProductRecommendation: '竞品信息',
    MainPushStyleSalesRanking: '款式销量排行榜',
    ContainerDimensions: '装柜尺寸',
    AccountHierarchySettings: '账号上下级设置',
    ExReservationInvitationSummary: '展会预约',
    ToDoReminder: '待办事项',
    newPrices: '价格',
    quotationSheet:'报价单',
    rai:"离职继承",
    mwhCompetitorFeatures:"竞品产品特点",
    Competitorslist:"竞品相关",
    loginlog:"登录日志",
    Account:"账户",
    createdAccount:"账户管理"
  },
  others: {
    DFSEDIInvolce: {
      lnvoiceCode: "发票",
      ExportEDIFile: "导出EDI文件",
      EDIFileName: "EDI文件名",
      ExportPOFile: "导出PO文件",
    },
  },
  dash: {
    Year: "请选择年",
  },
  Home: {
    Department: "请选择部门",
    OverdueAmount: "逾期金额",
    SaleAmount: "销售总额",
    charTitle1: "月销售额同比",
    charTitle2: "接单出货订单表",
    charTitle3: "客户销售排名",
    charTitle4: "逾期金额排名前十",
    charTitle5: "款式销售排名前十金额占比",
    charTitle6: "部门款式销售排名前十金额占比",
    charTitle7: "颜色排行销售排行前十",
    charTitle8: "部门颜色排行销售排行前十",
    tbTitle1: "客户名称",
    tbTitle2: "本月销售金额",
    tbTitle3: "去年同期",
    tbTitle4: "应收总额",
    tbTitle5: "月同比",
    more: "更多",
    lastYear: "去年",
    thisYear: "今年",
    color:'颜色',
    money:'金额',
    radio:'占比'
  },
  menusObj: {
    menu_title1: "首页",
    menu_title2: "客户",
    menu_title3: "订单",
    menu_title4: "报表",
    menu_title5: "出差",
    menu_title6: "竞品",
    menu_title7: "商品",
    menu_title8: "展会",
    menu_title9: "视频",
    menu_title10: "知识库",
    menu_title11: "业绩",
    menu_title12: "图片和视频",
    menu_title13: "模型",
    menu_title14: "价格",
    menu_title15: "客户价目表",
    menu_title16: "市场",
    menu_title17: "portalCommitments",
  },
  pageTitle: {
    TravelList: "出差列表",
    Customer: "客户",
    Order: "订单",
    OrderStatus: "订单状态",
    CustomerDet: "客户详情",
    CompetitiveProductAnalysis: "竞品分析"
  },
  CustomerPage: {
    tipsInfo:"上传图片不是标准16:9长宽比例主图，会影响导出展示，请尽量上传标准长宽比例产品图",
    comments:'SPECIAL INSTRUCTIONS / COMMENTS',
    VNCSR: '越南跟单',
    CNCSR:'中国跟单',
    VPAssistant:'VP助理',
    SalesRepresentive:'海外sales',
    RegionalVP:'海外VP',
    MWVP:'敏华海外VP/SALES/助理/跟单员信息',
    CompensationratioofRejection:'拒收赔偿比例',
    CreditPeriodDays:'信用期限(天)',
    ExpiryDate:'额度到期日期',
    EffectiveDate:'额度生效日期',
    Credit: "保险额度",
    InsuranceCompany: "保险公司",
    CREDITTRADEREFERENCES:'保险信息',
    rate:'同比%',
    sato:'接单统计分析表',
    tips:'当前款式已有主图，是否确认替换?',
    price:"销售价",
    priceSecond:"FOB工厂价",
    prices:"FOB审批价",
    MainImage:"是否主图",
    SkuClass:"款式类型",
    Variation:"变式",
    Sponge:"海绵",
    tabTitle1: "销售总额",
    tabTitle2: "款式排行",
    tabTitle3: "船务异常费用",
    tabTitle4: "Line Up",
    tabTitle5: "客户折扣汇总",
    OverdueAmount: "逾期金额",
    AccountReceivable: "应收款",
    tb1: "姓名",
    Cnumber: "客户编号",
    Cname: "客户名称",
    Country: "国家/地区",
    City: "城市",
    PoCode: "邮政编码",
    tel: "电话",
    addr: "地址",
    InCompany: "保险公司",
    paymentTerm: "付款条件",
    CreditLine: "信用额度",
    wip: "订单金额汇总",
    AmountReceivable: "应收款",
    TOT: "贸易条款",
    STP: "货物送达方",
    Confirm: "意向等级",
    Fabric: "面料",
    quty: "意向柜数",
    CType: "客户类型",
    AddBusinessCard: "添加名片",
    Attachment: "添加附件",
    Remark: "备注",
    AddCustomer: "新增意向",
    CustomerDet: {
      thTitle1: "时间",
      tnouo:"未出货金额",
      thTitle2: "本月销售金额",
      thTitle3: "去年同期",
      thTitle4: "月同比",
      thTitle5: "费用类型",
      thTitle6: "本期金额",
      thTitle7: "销售金额",
      thTitle8: "模型",
      thTitle9: "规格",
      thTitle10: "产品代码",
      thTitle11: "SKU号",
      thTitle12: "款式",
      thTitle13: "规格",
      thTitle14: "物料号",
      thTitle14s:"物料号",
      thTitle15: "国贸条款",
      thTitle16: "材质",
      thTitle17: "颜色",
      thTitle18: "成交价",
      thTitle19: "本年累计出货金额",
      thTitle20: "去年累计出货金额",
      thTitle21: "累计出货额同比增长",
      thTitle22: "图片",
      thTitle23: "本期累计出货金额",
      thTitle24: "出货金额对比销售金额",
      thTitle25: "品牌",
      thTitle26: "失效日期",
      thTitle27: "销售部门",
      thTitle28: "上期累计出货金额",
      thTitle29: "同期对比",
      thTitle30: "本期累计出货数量",
      thTitle31: "上期累计出货数量",
      thTitle32: "出货数量对比销售数量",
      thTitle33:"开票金额",
      thTitle34: "开票数量",
      thTitle35: "首次出货日期",
      thTitle36: "客户成交价",
      thTitle37: "FOB价(含关税)",
      thTitle38: "FOB价",
      thTitle39: "客户成交(含关税)",
      thTitle40: "{t} 预算总金额",
    },
    modelTye: "客户新款",
    yes: "是",
    no: "否",
    saleDept: "销售部门",
    LineUp: {
      blankets: '皮/布',
      spec: '规格',
      level: '档次',
      model: '款式',
      sku: '规格',
      coverCode: '色号',
      coverName: '颜色名称',
      fobPrice: '售价',
      picture: '图片',
      floorDisplays: '摆场数',
      budget: '{t} 年预算',
      previousYearJanDec: '{t} 全年销售额',
      salesYTD: '{t} 销售额',
      samePeriodSalesPreviousYear: '{t} 同时段销售额',
      growthRate: '增长率',
      openOrders: '未出货订单柜数',
      introductionDate: '首次出货日',
      status: '状态',
      year: '年',
      amount: '金额',
      addFloorSlot: '添加为店面现有'
    }
  },
  Customer: {
    CustomerManagement: "客户管理",
    state: "地区",
    LocalRanking: "当地排名",
    CustomerAnualSales: "年度生意额",
    ApproxFurnitureSales: "大约沙发生意额",
    ManWahSales: "今年敏华生意额",
    TargetSales: "今年目标生意额",
    AddNewCustomerData: "新增客户数据添加",
    CustomerInformationion: "客户情况表",
    ViaitingTimeLately: "拜访时间",
    StoreNumber: "门店数量",
    level: "等级",
  },
  OrderPage: {
    tabTitle1: "全部",
    tabTitle2: "订单创建",
    tabTitle3: "已签订",
    tabTitle4: "工厂确认",
    tabTitle5: "生产中",
    tabTitle6: "完工在库",
    tabTitle7: "已发货",
    Order: "销售订单",
    OrderDate: "下单日期",
    PONO: "客户订单号",
    Destination: "目的地",
    PaymentTerms: "付款方式",
    payTerms: "付款条件",
    Period: "占位日期",
    indexTb: {
      t1: "客户代码",
      t2: "客户名字",
      t3: "订单创建",
      t4: "已签订",
      t5: "工厂确认",
      t6: "生产中",
      t7: "完工在库",
      t8: "已发货",
      t9: "全部",
    },
    thead: {
      title1: "款式",
      title2: "规格",
      title3: "颜色特性",
      title4: "订单数量",
      title5: "单价",
    },
    orderlist: {
      th1: "客户要求交期",
      th2: "收客户po日期",
      th3: "占位时间",
      th4: "款式",
      th5: "颜色特性",
      th6: "品牌类别",
      th7: "预计到料日",
      th8: "实际到料日 ",
      th9: "预计完工日",
      th10: "预计开船日",
      th14: "预计到港日",
      th11: "Actual Completion Date",
      th12: "货柜号",
      th13: "POD状态",
      th15: "发票号",
      th16: "发票金额",
      th17: "实际完工日期",
    },
  },
  OrderAverageDeliveryTime: {
    shipped: '已发货',
    unshipped: '未发货',
    orderCreateTime: '订单创建年月',
    orderOccupationTime: '订单占位年月',
    no: '序号',
    vpSales: 'VP/Sales',
    customerName: '客户名称',
    cargoState: '货物状态',
    orderQuantity: '订单数量',
    orderA2C: '订单A→C',
    orderC2D: '订单C→D',
    orderD2Completed: '订单D→实际完工',
    orderCompleted2Vanning: '订单完工→装柜',
    orderCompleted2Delivery: '装柜→发货过账',
    total: '总周期(订单A→发货过账)',
    exportFileName:'客户平均货期'
  },
  reportItem: {
    Title: "报表",
    ItemTitle1: "销售净额分析表",
    ItemTitle2: "应收账款逾期账龄分析表",
    ItemTitle3: "接单出货订单表",
    ItemTitle4: "船务异常费用",
    ItemTitle5: "出口在库完工柜报表",
    ItemTitle6: "客户销售汇总排名",
    ItemTitle7: "销售颜色汇总排名",
    ItemTitle8: "款式销售汇总排名",
    ItemTitle9: "销售明细表",
    ItemTitle10: "业务接单情况表",
    ItemTitle11: "业务出货及收入情况表",
  },
  reportpage1: {
    Ccode: "客户代码",
    VPname: "VP名",
    Cname: "客户名称",
    title1: "本月发票金额",
    title2: "去年同期发票金额",
    title3: "同比变化率",
    title4: "今年发票金额",
    title5: "去年发票金额",
    title6: "同比变化率",
    NTitle1: "规格",
    NTitle2: "意向柜数",
    NTitle3: "落实订单件数",
    NTitle4: "总金额(USD)",
    NTitle5: "落实柜数",
  },
  reportpage2: {
    days: "天",
    Ccode: "客户代码",
    Cname: "客户名称",
    title1: "保险公司",
    title2: "付款条件",
    title3: "应收金额",
    title4: "逾期金额",
    title5: "最后付款日期",
    title6: "上次付款金额",
  },
  reportpage4: {
    Ccode: "客户代码",
    Cname: "客户名称",
    ChassisFee: "超期车架费用",
    DropPickUpFee: "返空/还空柜费",
    PrePull: "外拖费",
    YardStorage: "堆存费",
    OverTimeWaiting: "超时费",
    Demurrage: "码头/火车站舱租",
    ChassisSplit: "车架分离费",
    CustomsExam: "海关查柜费",
    ECD: "额外送货费",
    Totalcost: "额外费用总计",
  },
  reportpage5: {
    amercement:"扣款金额",
    ordersWithoutSO: "无SO订单数",
    ordersWithSO:"有SO订单数",
    totalOrders:"订单总数",
    finishedGoodsInventoryInformationReport: '在库订单SO情况',
    finishedGoodsInventoryAgeReport: '在库天数信息报表',
    ECDDTR:"出口客户交期跟踪报表",
    orderWithSO: '已拿SO柜数',
    orderWithoutSO: '未拿SO柜数',
    inventory: '在库库存',
    dept: '销售部门',
    customerName: '客户名称',
    tradeTerms: '国际贸易条款',
    tradeTerms2: '国际贸易条款2',
    lessThan15days: '15天以下',
    between15and30days: '16-30天',
    between30and60days: '31-60天',
    between60and90days: '61-90天',
    between90and120days: '91-120天',
    between120and150days: '121-150天',
    between150and180days: '151-180天',
    over180days: '180天以上',
    stockDays: '在库天数',
    stockDaysScope:"在库天数范围",
    PI: 'PI号',
    customerPO: '客户PO号',
    model: '型号',
    spec: '规格',
    material: '面料',
    color: '颜色',
    fob: '价格',
    qty: '订单数量',
    finishedDay: '完成时间',
    hasSolution: '有/无解决方案',
    solution: '处理方案',
    viewScope: '查看范围',
    more60Days: '60天以上',
    vbeln: 'PI号',
    openingDate: '开仓日期',
    zjsi: '截SI日期',
    closingDate: '截关日期',
    etd: '预计到港日',
    unit: '单位：柜数',
    vpAssistance: 'VP助理',
    csr: '跟单',
    customerCode: '客户代码',
    incoterms: '国贸条款',
    orderAmount: '订单金额',
    actuallyFinishedDate: '实际完工日',
    so: 'SO号',
    eta: '预计开船日',
    soStatus: 'SO情况',
    soTrue:"有SO",
    soFalse:"无SO",
  },
  reportpage8_7: {
    title0: "颜色编码",
    title1: "款式",
    title2: "本月销售净额",
    title3: "占比",
    title4: "去年本月销售净额",
    title5: "占比",
    title6: "同比变化率",
    title7: "今年累计销售净额",
    title8: "去年累计销售净额",
    title9: "同比变化率",
    Country: "国家/地区",
    code: "代号",
    name: "名称",
    dept: "销售部门",
    ctn: "在库柜数",
    Cname: "客户名称",
    TradeTerms1: "国际贸易条款1",
    TradeTerms2: "国际贸易条款2",
  },
  reportpage9: {
    tips1: "接单开始日期不能大于结束日期",
    tips2: "开票开始日期不能大于结束日期",
    tips3: "接单只能导出半年内数据",
    tips4: "开票只能导出半年内数据",
    tips5:"装柜材积必须在2000ft³-2350ft³之内",
    tips6:"装柜材积必须在56.63m³-66.54m³之内",
    tips7:"订单中同一款式存在多个颜色，请注意！",
    tips8:"不可发送",
    search: {
      title1: "部门",
      title2: "接单日期",
      title3: "工厂",
      title4: "开票日期",
      title5: "材质",
    },
    thTitle: {
      title1: "客户代码",
      title2: "客户名称",
      title3: "VP",
      title4: "销售名称",
      title5: "销售部门",
      title6: "品牌",
    },
  },
  reportpage10: {
    tips1: "接单开始日期不能大于结束日期",
    tips2: "开票开始日期不能大于结束日期",
    tips3: "接单只能导出半年内数据",
    tips4: "开票只能导出半年内数据",
    search: {
      title1: "部门",
      title2: "VP/Sales",
      title3: "客户名称",
      title4: "年月",
    },
    thTitle: {
      title1: "序号",
      title2: "部门",
      title3: "VP/Sales",
      title4: "客户",
      title5: "出差时间",
      title6: "展会名称",
      title7: "意向柜数",
      title8: "确认柜数",
      title9: "上月接单柜数",
      title10: "上月接单金额",
      title11: "去年上月接单柜数",
      title12: "去年上月接单金额",
      title13: "上月金额同比增长%",
      title14: "本月接单柜数",
      title15: "本月接单金额",
      title16: "去年同期接单柜数",
      title17: "去年同期接单金额",
      title18: "本月金额同比增长%",
      title19: "本年累计接单柜数",
      title20: "本年累计接单金额",
      title21: "去年累计接单柜数",
      title22: "去年累计接单金额",
      title23: "累计接单金额同比增长%",
    },
  },
  reportpage11: {
    tips1: "接单开始日期不能大于结束日期",
    tips2: "开票开始日期不能大于结束日期",
    tips3: "接单只能导出半年内数据",
    tips4: "开票只能导出半年内数据",
    search: {
      title1: "部门",
      title2: "VP/Sales",
      title3: "客户名称",
      title4: "年月",
    },
    thTitle: {
      title1: "序号",
      title2: "部门",
      title3: "VP/Sales",
      title4: "客户",
      title5: "上月出货柜数",
      title6: "金额",
      title7: "折扣",
      title8: "佣金收入",
      title9: "本月应出货柜数",
      title10: "金额",
      title11: "下月以后出货柜数",
      title12: "金额",
    },
  },
  report20: {
    CRL:"客户排行榜",
    fobPrice:"出厂价",
    classification: "档次",
    leather: "皮类",
    Fabric: "布类",
    mwSlot: "敏华现有",
    floorSlot: "店面现有",
    picture: "图片",
    rank: "排名",
    FOBPrice: "零售价",
    LandedPrice: "Landed审批卖价",
    RetailPrice: "零售价",
    total: '汇总Total',
    suppliers: '供应商',
    storeNumber: '门店数',
  },
  Competing: {
    tabTitle1: "竞品标题",
    tabTitle2: "竞品金额",
    tabTitle3: "竞品信息",
    formlable0: "竞品标题",
    formlable1: "竞品金额",
    formlable2: "竞品详情",
    formlable3: "备注",
    formlable4: "上传人",
    formlable5: "日期",
    formlable6: "国家/地区",
  },
  competingGoodsInfo: {
    title1: "SKU",
    title2: "说明",
    title3: "平方",
    title4: "长度",
    title5: "深度",
    title6: "价格",
    title7: "总价格",
    Commitments: "展会列表",
  },
  formlabel: {
    exportExcel2:"包含主图跟副图",
    exportExcel1:"只包含主图",
    exportExcel: "导出Excel",
    exportPdf: "导出PDF",
    label1:'客户邀约资料报表',
    label2:'客户邀约资料更新模板',
    label3:'分页导出',
    label4:'合并导出',
    label5:'交期信息明细表',
    label6:'客户回签信息明细表',
    label7:'在库天数逾期报表',
    label8:'出口业务部在库天数数据分析',
    download:"下载上传模版",
    createdDate:"创建日期",
    updateDate:"更新日期",
    Month: "月度",
    Quarter: "季度",
    Year: "年度",
    ResetBtn: "重置",
    SearchBtn: "搜索",
    SingleBtn1: "接单订单",
    SingleCount:"接单总数",
    SingleBtn2: "出货订单",
    SingleCounts:"出货总数",
    ReturnBtn: "返回",
    addBtn: "添加",
    submitBtn: "提交",
    editBtn: "编辑",
    Department: "部门",
    downloadbtn: "下载",
    downloadTemplate: "下载模板",
    upload: "上传",
    cancel: "取消",
    Selectfile: "选择文件",
    classify: "分类",
    title: "标题",
    delete: "删除",
    handle: "操作",
    keyword: "关键字",
    createCommitment: "创建",
    import: "导入",
    export: "导出",
    exportData: "导出报表",
    exportDatas:"导出意向订单列表",
    exportType: "客户邀约流程表",
    exportDataThree:"导出订单状态",
    exportDataSecond: "导出意向订单",
    exportDataAll:"导出意向订单品类明细",
    exportDataAllT:"导出订单状态明细",
    exportCountSheet:"导出订单汇总",
    Count:"总合计",
    partExport: '部分导出',
    allExport: '全部导出'
  },
  Performance: {
    tabTitle0: "客户名称",
    tabTitle1: "预算",
    tabTitle2: "实际",
    tabTitle3: "实际",
    tabTitle4: "目标达成率",
    tabTitle5: "同期对比",
    tabTitle6: "预算",
    tabTitle7: "实际",
    tabTitle8: "实际",
    tabTitle9: "目标达成率",
    tabTitle10: "同期对比",
    tabTitle11: "全年实际",
    Division1: "Total",
    Division2: "出口二部",
    Division3: "出口三部",
    cabinet: "柜数",
    Budget: "2024年1-12月预算",
    Acutal1: "2023全年",
    Acutal2: "2019全年",
    vpassistant: "VP助理",
    ESAPC: "客户销售情况表",
    BIT: "预算导入模板",
  },
  Documents: {
    uptime: "上传日期",
    filetitle: "文件标题",
    usDp:'美国事业部'
  },
  timeOptions: {
    today: "今天",
    oneMonthAgo: "一个月前",
    threeMonthAgo: "三个月前",
    sixMonthAgo: "半年前",
    startPlaceholder: "开始日期",
    endPlaceholder: "结束日期",
  },
  TravelList: {
    byway: "Others",
  },
  ModelsDet: {
    title: "定价和图像",
  },
  Hello: "你好",
  PleaseEnter: "请输入",
  PleaseSelect: "请选择",
  Brand: "品牌",
  DepPleaseSelectBrand: "请选择品牌",
  DepPleaseSelectFactory: "请选择工厂",
  psdiv:"请选择事业部",
  StartDate: "开始时间",
  EndDate: "结束时间",
  Date: "日期",
  MonthRange: "ETD日期",
  types: "类型",
  PleaseSelectType: "请选择类型",
  modifyPassword: "修改密码",
  oldPassword: "旧密码",
  newPassword: "新密码",
  confirmPassword: "确认密码",
  confirm: "确 认",
  logout: "退 出",
  firstLogin: "首次登录或密码过于简单",
  PleaseEnterNewPassword: "请输入新密码",
  passwordRequirements: "密码必须是8位以上的大写字母、小写字母、数字的组合",
  PleaseConfirmPassword: "请再输入一次",
  confirmError: "两次输入的密码不一致",
  passwordNoChange: "新密码不能与旧密码相同",
  logoutConfirm: "确定注销并退出系统吗？",
  order: {
    Division : "事业部",
    Market: "市场",
    PleaseEnterTheSearchKeyword: "请输入搜索关键字",
  },
  newPriceList:{
    Comments:"评论",
    Created:"创建",
    Updated:"更新",
    Link:"关联",
    Rep:"Rep",
    entries:"条目",
    typeToFilter:"筛选类型",
    pricelistForm:"价格表单",
    createdPricelist:"确认价格表单",
    columns1:"越南/加拿大",
    columns2:"CFR",
    columns3:"FOB",
    title1:'条款',
    columns4:"图片"
  },
  prices: {
    quoteRequired:"报价单必选",
    quoteLabel: "报价单",
    newPriceList:"新增价目表",
    priceLists:"价格列表",
    radio1:"产品资料",
    radio2:"手动添加",
    radio3:"SAP",
    titleInfo:"来源",
    errorTip:'组合名称和功能必填',
    errorTips:"选择的价格重复，不可添加",
    priceStart:"价格开始",
    priceEnd:"价格结束",
    Function: "功能",
    PieceCount: "件数",
    CoverGrade: "表面等级",
    CoverType: "表面材质",
    MotionType: "移动类型",
    category: "种类",
    MaterialInfo: "请选择颜色等级",
    MaterialClass: "请选择材质类型",
    PowerClass:"请选择功能类型",
    style:"请输入款式",
    factory:"请选择工厂",
    search:"查询",
    description:"商品名称",
    Cubes:"材积(ft³)",
    Cube:"材积(m³)",
    length:"包装后长(in)",
    Depth:"包装后宽(in)",
    height:"包装后高(in)",
    lengths:"包装后长(cm)",
    Depths:"包装后宽(cm)",
    heights:"包装后高(cm)",
    vietnamP:"越南FOB价格",
    cnP:"中国FOB价格",
    Type:"材质等级",
    Edit:"编辑",
    change:"修改",
    sceneGraph:"场景图",
    rawPic:"白底图",
    priceTickets: "价格牌",
    back:"返回",
    clickPreview:"点击材质等级查看所有价格",
    pricesImportTemplate: "价格导入模板",
    exportPriceSheet:"导出报价单",
    addPriceSheet:"新增到报价单",
    priceSheetFileName:"报价单文件名",
    priceSheetColorNum:"选择报价单颜色编号",
    selectPic:"为报价单选择一张图片",
    quoteSheet:"报价单",
    chooseCover:"可选色",
    priceSheetName:"报价单名称",
    addNewPriceSheet:"创建报价单",
    addToPriceSheet:"添加到报价单",
    specificationNum:'规格数量',
    view:"查看",
    allPrice:"全部价格",
  },
  Report: {
    PleaseEnterCodeOrName: "请输入客户代码或者名称",
    PleaseEnterNameSearch: "请输入姓名进行搜索",
    AllTypes: "所有类型",
  },
  /*此处上边翻译已进行修改*/
  loading: "加载中",
  noMore: "没有更多了",
  ALLTYPES: "所有类型",
  model: "型号",
  Temporarily: "暂无数据",
  menu: {
    menu_title15: "市场列表",
    menu_title16: "意向列表",
    menu_title17: "展会接单情况表",
    menu_title18: "模型概括",
  },
  Commitments: {
    exportMes:'导出产品信息',
    area:'区域',
    footerTips:"已经到底啦",
    id: "序号",
    NewModelLaunchDate: "新款上线时间",
    MarketsStartDate: "展会开始时间",
    MarketsEndDate: "展会结束时间",
    NewModelOrigin: "新款来源",
    OldModelReExhibit: "是否老款重展",
    OrderCutofftime: "订单截止日期",
    ShippingCutoffTime: "出货截止日期",
    Maintainer: "维护人",
    MaintenanceDate: "维护日期",
    MaterialNumber: "物料号",
    DescCombination: "规格组合",
    MaintainTemplate: "新款维护模板",
    ArrangementMaintainTemplate: "规格维护模板",
    ExhibitionBonusDistributionTemplate: "展会奖金分配模板",
    ExhibitionBonusStylesTemplate: "展会奖金款式模板",
    MarketNameCN: "展会名称-中文",
    MarketNameEN: "展会名称-英文",
    SalesDepartment: "销售部门",
    OrderPlaceDate: "下单日期",
    CustomerConfirmedDate: "确认日期",
    VPSales: "VP/Sales",
    CommitmentQTY: "意向订单柜数",
    ConfirmedOrderQTY: "确认订单柜数",
    ConfirmedOrderAMT: "确认订单金额",
    PODate: "确认订单日期",
    RequestedReadyDate: "出货日期",
    ReasonForNotOrdering: "未下单原因",
    BonusMonth: "奖励月份",
    Nationality: "业务国家/地区",
    OverdueDays: "逾期天数",
    MaterialCode: "物料编码",
    StyleSpecifications: "款式规格",
    POOrderNumber: "PO单号",
    LineItemNumber: "行项目号",
    Title: "职位",
    Describe: "描述",
    StartDate: "开始时间",
    endDate: "结束时间",
    Country: "国家/地区",
    companyName:'公司名称',
    CommitmentsList: "意向清单",
    AddMarket: "新增展会",
    MarketsList: "展会", //市场名单
    Market: "展会",
    MarketsName: "展会名称",
    NewCustomer: "新客户",
    CustomerName: "客户名称",
    selectCustomerName: "请选择客户名称",
    selectCountry: "请选择国家",
    saleDeptInp: "请输入销售部门",
    Sales: "Sales",
    Covers: "封面",
    Confirm: "认证",
    Edit: "操作",
    Arrangements: "布局",
    CustomerType: "客户类型",
    NumberOfOrders: "订单数量",
    OrderAmount: "订单金额",
    TotalAmount: "总金额",
    Color: "颜色",
    quantity: "数量",
    IMIC: "展会邀请客户信息",
    IMICT: "展会邀请客户信息模板",
    AnnualTurnover: "年度营业额",
    ViaitingTimeLately: "上次拜访客户时间",
    Company: "客户名称",
    Customer: "负责人",
    StoreNumber: "门店数量",
    MarketTime: "预约到展会时间",
    NewReGularCustomer: "新/老客户",
    Email: "联系方式",
    Division: "事业部",
    AddExReservation: "新增展会预约",
    AddNewCustomerData: "新增客户数据添加",
    create: "创建",
    CommitmentConfirm: "意向订单确认",
    vpSalesExport: "VP/Sales 导出",
    officeExport: "出口办导出",
    expectedFactoryDate: '预计访厂日期',
    actualFactoryDate: '实际访厂日期',
    whetherAttendParty: '是否参加派对',
    partyAttendanceNum: '派对出席人数',
    sofaSales: '大约沙发生意额',
    mwSales: '敏华生意额',
    percentage: '敏华生意额占比',
    mUnit: 'Unit M($)',
    marketRanking: '市场排名',
    countryState: '国家/地区',
    countryStates:'客户国家/地区',
    nationalitys:"VP/Sales国籍",
    state: '州',
    viewExhibitionCalendar: '查看展会日历',
    exhibitionCalendar: '展会日历',
    appointmentList: '预约列表',
    approvalList: '审批列表',
    submitForApproval: '提交审批',
    status: '状态',
    approvalStatus: '审批状态',
    pendingSubmission: '待提交',
    pendingReview: '待审核',
    pendingApproval: '待审批',
    approved: '审批通过',
    rejected:'已驳回',
    recall: '撤回',
    clientsToInvite: '邀约客户数',
    approverComments:'负责人审批意见',
    generalManagerApproval:'总经理审批意见',
    view: '查看',
    approval: '审核',
    exhibitionDepartment: '参展事业部',
    appointmentApprovalProcess: '预约审批流程',
    CustomersToInvite: '需邀约客户数',
    RegularCustomers: '老客户数',
    NewCustomers: '新客户数',
    detail: '明细',
    agree:'通过',
    reject:'驳回上一级',
    reject1:'驳回给业务',
    reviewComments:'审核意见',
    approvalComments:'审批意见',
    nextClientVisitDate: '下次客户拜访日期',
    meetingContent: '会议内容',
    remark: '备注',
    toBeInvited: '待邀约',
    hasBeenInvited: '已邀约',
    retailer: '零售商',
    wholesaler: '批发商',
    online: '电商',
    updateDate: '更新时间',
    addAppointment: '添加展会预约客户',
    actualVisitMarketTime: '实际到展时间',
    marketArrivialConfirm: '确认到展'
  },
  no:'序号',
  Tips: "提示",
  PleaseSelectTheDownloadMethod: "请选择下载方式!?",
  Download: "下载",
  CopyLinks: "复制链接",
  Receivables: "逾期应收账款",
  OrderInput: "订单输入汇总",
  OrderInputDetailList: "订单输入明细表",
  Firstlevelreport: "一级报告",
  Secondaryreport: "二级报告",
  VisitTime: "访问时间",
  addTravel: {
    CustomerName: "请输入客户名称",
    PleaseInputContacts: "请输入联系人",
    CustomerLocation: "请输入客户所在地",
    CustomerDetailsP: "请输入客户资料",
    Opportunity: "请输入感想",
  },
  addCompetitors: {
    PleaseInputTitle: "请输入标题",
    PleaseInputAmount: "请输入金额",
    PleaseInputDetails: "请输入详细信息",
    PleaseInputCustomerDescribe: "请输入客户描述",
    PleaseInputUserName: "请输入用户姓名",
    selectdate: "选择日期",
  },
  AmountIsNotANumber: "金额不是数字",
  CountryNotselected: "未选择国家",
  FileIsNull: "文件为空",
  UploadPicturesCaninJPGformat: "上传图片只能是JPG格式",
  addSuccess: "添加成功",
  PleaseInputcovers: "请输入覆盖物",
  editPricelist: "编辑价目表",
  PleaseSelectModel: "请选择型号",
  factory: "工厂",
  PleaseSelectArrangements: "请选择布局",
  PleaseInputSku: "请输入sku",
  PleaseInputDescription: "请输入说明",
  PleaseInputCubes: "请输入平方",
  PleaseInputLength: "请输入长度",
  PleaseInputDepth: "请输入深度",
  PleaseInputPrice: "请输入价格",
  AddVideo: "添加视频/图片",
  EditVideo: "编辑视频/图片",
  AddCover: "添加面料",
  EditCover: "编辑面料",
  PleaseInputColor: "请输入颜色特性",
  PleaseInputTitle: "请输入标题",
  uploadDocuments: "上传文档",
  Normal: "普通",
  LifeStyle: "生活时尚",
  Closeup: "特殊的",
  Videos: "视频",
  CatalogPages: "目录页",
  ConfirmOperation: "确认操作",
  Downloads: "下载",
  AddtoEmail: "添加邮件",
  Small: "小型的",
  Medium: "中等的",
  Large: "大型的",
  HiRes: "视觉效果图",
  SendContentViaEmail: "通过电子邮件发送内容",
  ToSendToMultipleEmails: "要发送到多个电子邮件，请在地址之间添加一个 com",
  AddData: "添加数据",
  ClientName: "客户名称",
  PleaseInputBudge: "请输入预算",
  PleaseInput: "请输入",
  BatchImport: "批量导入",
  SelectFile: "选择文件",
  level: "等级",
  ImagesAndVideo: {
    EmailTo: "电子邮件地址",
    Subject: "标题",
    Body: "内容",
    SendEmail: "发送电子邮件",
    Clear: "清除",
    remove: "删除",
    type: "类型",
  },
  price: {
    modifyFunctionName:"修改功能名称",
    modifyTheCombinationName:"修改组合名称",
    addtoTheOriginalCombination:"添加到原组合",
    createNewCombination:"创建新组合",
    combinationName:"组合名称",
    TypeToFilter: "要过滤的类型",
    Current: "品牌",
    NewModel: "新模型",
    table: {
      Image: "图片",
      Model: "型号",
      Brand: "品牌",
      Current: "Current",
      Arms: "Arms",
      Backs: "靠背",
      Seats: "Seats",
      Mechanisms: "Mechanisms",
      Features: "特点",
      Styles: "风格",
      Collections: "系列",
      Categories: "类别",
      Remarks: "评论",
      handle: "操作",
      noPic:"暂无图片"
    },
    From: {
      ModelForm: "模型形式",
      Name: "名称",
      Remarks: "评价",
      Style: "风格特征",
      Construction: "结构",
      CountryOfOrigin: "原产地",
      Unique: "独特的",
      Arms: "Arms",
      CreateModel: "创建模型",
      Close: "关闭",
    },
  },
  ShippedOrderSummary: "发货订单汇总",
  ShippedDetailList: "出货明细表",
  util: {
    CopySuccess: "复制成功",
    ImageAddedtoEmail: "图片已添加到电子邮件",
    ImageAlreadyInEmail: "图片已在电子邮件中",
  },
  resetPassword: {
    username: "用户名",
    pleaseEnterUsername: "请输入用户名",
    reset: "重置",
    resetSuccess: "重置成功",
    confirmReset: "确认重置密码？",
    tip: "提示",
  },
  covers: {
    coverName: "面料名",
    coverNumber: "面料号",
    coverGroup: "面料组别",
    coverType: "面料类型",
  },
  modelStatus: {
    running: "主推",
    newModel: "新款",
    newCover: "新款",
    phasedOut: "逐步淘汰",
    dropped: "取消",
  },
  Admin: {
    bd: "所属事业部",
    role: "角色",
    account: "账户",
    NOL:"登录人数",
    TL:"总账户数",
    AP:"活跃占比",
    confirmInheritanceMessage:"是否确定继承？一旦确认，改操纵无法撤销",
    mes1:"（注意：继承人将继承离职人的展会客户信息，竞品信息，上下级关系等，一旦操作数据不可撤销）",
    relevantP:'相关人员',
    addRelationship:"新增离职与继承关系",
    ot:"操作时间",
    op:"操作人",
    inheritor:"继承人",
    fp:"离职人",
    rai:"离职继承",
    ariA:"离职人员数据继承",
    unit:"单位",
    index: "序号",
    name: "名称",
    code: "编码",
    weight: "重量",
    width: "宽度",
    height: "高度",
    isUsed: "启用",
    skuType: "SKU类别",
    seats: "座位数",
    description: "描述",
    arrangementType: "组合类别",
    motion: "功能",
    motionType: "功能类别",
    pieceCount: "件数",
    uniqueArrangment: "唯一规格",
    group: "组别",
    type: "类别",
    status: "状态",
    component: "成分",
    skin: "皮",
    add: "添加",
    edit: "编辑",
    save: "保存",
    yes: "是",
    no: "否",
    update:'修改',
    copy: "复制",
    active: "激活",
    inactive: "未激活",
    pleaseEnter: "请填写",
    pleaseSelect: "请选择",
    deleteInfo: "此操作将永久删除该数据, 是否继续?",
    promptInfo:"材积已到2200",
    errorInfo:"删除失败",
    confirm: "确定",
    cancel: "取消",
    tips: "提示",
    sentence:"不一致，无法创建",
    networkError: "网络错误",
    grade: "等级",
    color: "颜色",
    arms: "扶手",
    mechanisms: "功能铁架",
    backs: "靠背",
    features: "产品特点",
    seats2: "座包",
    styles: "风格",
    provenance: "产地",
    china: "中国",
    vietnam: "越南",
    chinavietnam: "中国或越南",
    mexico: "墨西哥",
    image: "图片",
    models: "款式",
    loadability: "装柜量",
    leather: "皮",
    content: "成分",
    categories: "类别",
    priceRange: "价格区间",
    cubes: "体积",
    coverGrade: "颜色等级",
    length: "长度",
    depth: "坐深",
    price: "价格",
    selectiveColor: "可选颜色",
    spec: "规格",
    cube: "材积",
    lwh: "产品尺寸 长*宽*高 (in)",
    packageSize: "包装尺寸 长*宽*高 (in)",
    packageMethod: "包装方式",
    addOnOption: "添加选购",
    addOnOption1: "加入选购清单",
    salesPrice: "销售价",
    amountSum: "金额小计",
    cubeSum: "材积小计",
    customized: "定制",
    pleaseEnterQTY: "请输入数量",
    containerCaculation: "算柜结算",
    settlementPO: "结算PO",
    settlementPOTips: '该PO订单已算柜',
    continue:'是否继续',
    container: '货柜',
    totalCargoVolume:'合计货物体积',
    quantityOfGoods: '货物数量',
    containerVolumeUtilizationRate:'货柜体积使用率',
    POSettlement: "PO结算",
    addtoPo: "添加到PO",
    poNo: "PO号",
    fax: "传真",
    buyer: "联系人",
    email: "邮箱",
    emailEnter: "多个邮箱请用英文分号隔开",
    freight: "运费",
    cabinetType: "柜型",
    POType: "PO类型",
    category: "类别",
    leading: "主推",
    marketNewModel: "展会新款",
    discountAmount: "折扣金额",
    ManufacturingPlant: "发货工厂",
    totalOrderAmount: "订单金额合计",
    package: "包装",
    authorizedSignature: "客户签名",
    signatureVerification: "签名确认",
    settingUp: "创建",
    closing: "关闭",
    closeOther: "关闭其他",
    closeAll: "关闭所有",
    emailStatus: "邮件状态",
    checkAll: "全选",
    SAPStatus: "SAP状态",
    sentSuccessfully: "发送成功",
    sent: '已发送',
    failToSend: "发送失败",
    PONo: "PO号",
    SAPPI: "SAP单号",
    subtotal: "合计",
    sendPo:"复制PO",
    sendToSap: "发送SAP",
    sendEmail: "发送邮件",
    exportPO: "导出PO",
    discountRate: "折扣率",
    salesDiscount: "销售折扣",
    clear: "清空",
    notSigned: "您还没有签名，确定提交吗？",
    amountTotal: "金额合计",
    cubeTotal: "材积合计",
    pleaseSelectPO: "请勾选要操作的数据",
    pleaseSelectAvaliablePO: "勾选的数据必须全部有效",
    confirmDelete: "确认删除？",
    offShelf: "下架",
    effective: "有效",
    view: "预览",
    userCode: "工号",
    AllocateAmount: "分配金额",
    position: "职位",
    readyDate: "客户要求交期",
    marketModel: "展会款",
    trait: "特性",
    all: "全部",
    material: "物料",
    qsInventoryAddCarError: '未存在可下单款式列表，请联系管理员更新',
    completeSetNumber: '整套编号',
    setQuantity: '成套数量',
    total: '合计',
    cis:"是否能发送",
    OTF:"架构所属",
    role:"角色",
    OFTHEDIV:"所属事业部",
    ArchitectureArea:"架构区域",
    BWC:"企微ID",
    nationality: "国籍",
    userAccount:"用户账户",
    addAccount:"创建账户",
    editAccount:"编辑账户",
    enable: "启用",
    disable: "注销",
    createdAccount:"账户管理",
    loginlog:"登录日志"
  },
  travel: {
    tvn:"拜访客户数",
    tDays:"出差天数",
    tnop:"总人数",
    nopwaoabt:"正在出差人数",
    ptnopt:"计划出差人数",
    tnopwhnt:"未出差人数",
    title: "出差",
    year: "年",
    month: "月",
    visitCustomer: "拜访客户",
    exportReport: "导出报告",
    travelName: "出差人",
    visitTime: "访问时间",
    visitMode: "拜访方式",
    country: "国家/地区",
    state: "州",
    fullAddress: "详细地址",
    customerDetail: "客户详情介绍",
    storeNum: "门店数",
    storeStyle: "款式数",
    mwStyle: "MW款式数",
    visitResult: "拜访结果",
    img: "出差图片",
    businessCard: "拜访名片",
    customerType: "客户类型",
    new: "新客户",
    old: "老客户",
    customerName: "客户名",
    tel: "电话拜访",
    face: "当面拜访",
    shop: "到店拜访",
    other: "其他",
    followUp: "待跟进事项",
    competitors: "竞品",
    company: "竞品公司",
    placementNum: "竞品摆场数",
    competitorStyle: "竞品款式",
    remark: "备注",
    date: "日期",
    notBeEmpty: "不能为空",
    orders: "订单",
    shipping: "交货",
    payment: "收款",
    quality: "品质",
    retailPrice: "参考零售价",
    TravelSchedule: "业务出差情况表",
    tips: "请选择至少一位 VP/Sales!",
    tips1: "请选择同一VP/Sales!",
    submitForApproval: '提交审批',
    approvalDataExists:'存在审批数据',
    vpAssistant: 'VP助理',
    approvalStatus: '审核状态',
    pendingSubmission: '待提交',
    pendingReview: '待审核',
    pendingApproval: '待审批',
    approved: '审批通过',
    approvalList: '审批列表',
    approval: '审批',
    travelPlan: '出差计划',
    approvalProcessPlanning: '计划审批流程',
    scheduledStartTime: '计划开始时间',
    scheduledEndTime: '计划结束时间',
    travelVPSales: '出差VP/Sales',
    travelVPAssistant:'出差VP助理',
    location: '地点',
    detail: '明细',
    prospectVisitTargets: "拜访意向客户数",
    agree:'通过',
    reject:'驳回上一级',
    recall: '撤回',
    view: '查看',
    reject1:'驳回给业务',
    rejected:'已驳回',
    reviewComments:'审核意见',
    approvalComments:'审批意见',
    approverComments:'负责人审批意见',
    generalManagerApproval:'总经理审批意见',
    viewCompetitor: '查看全部竞品信息',
    visitResults: '出差反馈',
  },
  InventoryPlatform: {
    SRL:"收SO-装柜",
    eta:"ETA",
    etd:"ETD",
    SRD:"收SO日期",
    LoadingDate:"装柜日",
    DeliverNo: "交货单",
    OAR:"变更原因",
    changeDays:"变更天数",
    PAFC:"生产确认天数 (回签-工厂确认)",
    FCD:"工厂初次确认日期",
    PCFT:"采购确认(首次)",
    PCD:"采购确认天数(回签-采购确认)",
    PAD:"回签日期",
    PD:"建单日期",
    adtips:'延期天数',
    ADOL:"延期天数(担保-ETD/ETA)",
    ASD:"出货天数(完工-ETD)",
    APD:"生产天数(回签-完工)",
    APAD:"回签天数(建单-回签)",
    ALT:"交期(建单-ETD)",
    TAPOS:"平均交期",
    seq: "序号",
    customer: "客户",
    customerCode: "客户代码",
    customerName: "客户名称",
    customerSKU: "客户SKU#",
    mwSKU: "敏华物料号",
    model: "款式",
    color: "颜色",
    item: "规格",
    fabricNumber: "面料编号",
    numberOfStore: "门店数量",
    storeFloorSampleQTY: "门店摆场数",
    status: "状态",
    createUser: "创建用户",
    createTime: "创建时间",
    operate: "操作",
    enable: "启用",
    disable: "停用",
    remark: "备注",
    save: "保存",
    saveSuccess: "保存成功",
    pleaseSelectData: "请选择数据",
    CustomerInventoryInfoTpl: "客户库存信息模板",
    ImportSuccessful: "导入成功",
    ProductInfo: "产品信息",
    ProductInfoTpl: "产品信息模板",
    customerDataTpl: "客户数据模板",
    WeekStartTime: "周开始时间",
    startMonth: "开始月份",
    CCD:'竞品创建日期',
    endMonth: "结束月份",
    WeekEndTime: "周结束时间",
    ThisWeekInvoice: "本周开单",
    undeliveriedQTY: "客户有单未送",
    CustomerInventory: "客户库存",
    ProductInTransit: "产品在途",
    ProductInStock: "成品库存",
    ReplenishmentQTY:"补货数量",
    ReadyDate:"完工时间",
    InProduction: "生产中",
    UnProduced: "已下单未生产",
    MeterialAvailableStock: "物料库存（面料）",
    MeterialInTransit: "物料在途（面料）",
    OrderQuantity: "订单数量",
    ShippedQuantity: "发货数量",
    ETD: "预计离港日",
    ETA: "预计到港日",
    Container: "货柜号",
    StockQTY: "库存数量",
    StockQTYs: "在库数量",
    IHOQ:"有单未出",
    RequestReadyDate: "业务要求完工日",
    EstReadyDate: "预计完工日",
    ActualReadyDate: "实际完工日",
    deleteConfirm: "是否删除所选记录?",
    prompt: "提示",
    confirm: "确定",
    cancel: "取消",
    deleteSuccessful: "删除成功",
    supplier: "供应商",
    shipTo: "目的地",
    customerPo:"客户PO",
    po: "订单号",
    PO:"PO#",
    weekDate: "周日期",
    uploadTip1: "文件大小不能超过5M",
    uploadTip2: "文档行数不能超过10000万行",
    IncorrectDownload: "异常下载",
    file: "文件",
    basicInfo: "基本信息",
    categoryId: '品类',
    sku: 'Sku',
    containerNumber: '预估柜数',
    features: '功能特点'
  },
  OrderDeliveryTimeOverviewOrDetail:{
    orderCreateTime: '订单创建月份',
    orderOccupationTime: '订单占位月份',
    custom: '客户',
    cycleConditions: '周期条件',
    orderA2Delivery: '订单A→发货',
    orderD2Delivery: '订单D→发货',
    month: '月',
    day: '天',
    invalidDateRange:'无效的日期范围',
    title1: '已发货平均货期走势(单位:天)',
    figure1: '平均货期',
    title2: '货期分布(单位:单数)',
    figure2: '货期分段',
    orderId: '订单号',
    totalDeliveryTime: '总货期',
    deliveryOrNot: '是否发货',
    orderCreareDate:'订单创建日期',
    firstDeliveryDate:'首次交期',
    currentStatus:'当前状态',
    orderA2C: '订单A→C',
    orderC2D: '订单C→D',
    reviewDateD:'首次审D日期',
    orderD2ExpectedCompleted:'订单D→预计完工',
    orderD2Completed: '订单D→实际完工',
    orderCompleted2Vanning: '订单完工→装柜',
    orderCompleted2Delivery: '装柜→发货过账',
    total: '总计',
    create:'创建',
    haveSigned:'已签订',
    siteValidation:'工厂确认',
    inTheProduction:'生产中',
    haveBeenCompleted:'已完工',
    installedCabinet:'已装柜',
    hasBeenShipped:'已发货',
  },
  CompetitiveProductAnalysisPage: {
    tup:'总上传进度',
    tur:'总上传率',
    nonCollaborated:'未合作',
    collaborated:'已合作',
      to:'至',
      table:{
         title1:'竞品分析',
         title2:'开始时间',
         title3:'结束时间',
         title4:'账户数量',
         handle:'操作',
         insert:'添加信息',
         view:'预览',
         division: '事业部',
         totalCustomerCount: '总客户数',
         competitorCustomersUploaded: '已上传竞品客户数',
         competitorCustomersNotUploaded: '未上传竞品客户数',
         uploadRate: '上传率',
         newRate:'上传进度',
      },
      materialList:"请选择材质",
      gradeList:"请选择档次",
      categoryList:"请选择品类",
      priceBandList:'请选择价格带(零售价$)',
      selectTips:"请选择",
      viewUploadedCompetitiveProductInformation: '查看已上传竞品信息'
  },
  CompetitiveProductAnalysisDataListPage:{
      country: '国家/地区',
      customerName:'客户名',
      vp:'VP',
      sales:'Sales',
      competitorNum:'上传竞品数量',
      recentUploadTime:'最近上传时间',
      uploader:'上传人',
      handle:'操作',
      save:'新增/编辑竞品',
      inset: '新增竞品',
      addCompany: '新增公司',
      editCompany: '编辑公司',
      view:'竞品预览',
      cd:'竞品与摆品',
      lastEditDate: '最后编辑时间',
      uploadDate: '上传时间',
      exportCompetingProducts: '导出竞品'
  },
    CompetitiveProductAnalysisStylePage: {
        company: '公司',
        Currency:'币种',
        exhibitionPrice:'展会价',
        covers:'面料清单',
        pdc:"产品类别",
        displaySection: '展示',
        tableSection: '表格',
        search: '搜索',
        add: '添加',
        update: '更新',
        delete: '删除',
        no:'否',
        yes:'是',
        filterPlaceholder:'请输入',
        addFrame: '添加款式',
        category: '产品分类',
        image: '图片',
        images:'副图',
        vendor: '供应商',
        price: '价格',
        cover: '面料',
        function: '功能',
        arrangementType: '组合类型',
        productName: '产品名',
        notes: '备注',
        onlineOnly: '是否仅为线上销售',
        classification: '档次',
        types: '推销类型',
        newFunctions: '推销功能',
        features: '功能特点',
        dimensionType: '尺寸',
        salesType: '状态',
        column: '栏位',
        floorDisplayNumber: '摆场数',
        fobPrice: '出厂价',
        priceRange: '价格区间(零售价$)',
        customer: '客户',
        model: '型号',
        type: '品类',
        size: '尺寸（长*宽*高）',
        leve: '档次',
        dragUploadText: '将文件拖到此处，或',
        clickUpload: '点击上传',
        uploadTip: '只能上传jpg/png文件，且不超过{size}MB',
        uploadImageFormatError: '只能上传jpg/png格式的图片文件',
        uploadImageSizeError: '上传文件大小不能超过{size}MB',
        uploadExceedLimit: '最多只能上传{limit}个文件',
        uploadFailed: '上传失败'
    },
  OrderIntake:{
    vpSales: 'VP/Sales',
    customerName: '客户',
    style: '款式',
    color: '颜色',
    status: '状态',
    monthDate: '交期',
    subtotal: '小计',
    total: '总计',
    spec: '规格',
    orderNum: '订单数量',
    quantity: '柜量',
    unitPrice: '单价',
    bookDate: '下单日期',
    salesOrder: '销售订单',
    customerOrderNumber: '客户订单号',
    occupancyDate: '占位日期',
    ordersReceivedLastMonth: '上月接单',
    numberOfDisplaySetups: '摆场数',
    TooC: '未出货柜数',
    lastMonthShipments: '上月出货',
    currentMonthDeliveries: '本月出货'
  },
  productRecommendation: {
    Division: '事业部',
    vpSales: 'VP/Sales',
    customer: '客户',
    style: '款式风格',
    businessId: '业务工号',
    material: '材质',
    category: '类别',
    level: '档次',
    model: '款式',
    specification: '规格',
    fabric: '面料',
    color: '颜色',
    size: '尺寸',
    functionFeatures: '功能特点',
    price: '价格区间 （美元）',
    recommendedReason: '推荐理由',
    recommendedPriority: '推荐优先级',
    followRecords: '跟进记录',
    exportProductRecommendationTemplate: '{t}产品推荐表模板',
    importProductRecommendationTableInformation: '{t}产品推荐信息',
    exportProductRecommendationTable: '{t}产品推荐表',
    exportProductRecommendationScheme: '{t}产品推荐方案',
    required: '必填'
  },
  MainPushStyleSalesRanking: {
    department: '部门',
    levelRanking: '档次排名',
    type: '材质',
    category: '品类',
    level: '档次',
    categoryRanking: '品类排名',
    model: '款式',
    running: '是否主推',
    fobPrice: 'FOB标准价',
    netSales: '{t}销售净额',
    cumulativeNetSales: '近半年累计销售净额',
    orderQuantityInIheNext3months: '未来3个月订单数量(件)  ({t})',
    customer: '主要客户',
    numbersOfDisplay: '摆场数',
    picture: '图片',
    mark: '备注',
    recommendedStatus: '推荐状态',
    ferth: '规格',
    color: '颜色',
    fandm:"规格/物料号"
  },
  ContainerDimensions: {
    materialNo: '物料号',
    packageSize: '包装尺寸:{t}(in)',
    length: '长',
    width: '宽',
    height: '高',
    dialogTitle: '{t} (单位:in)',
    uprightPosition: '立放',
    onSidePosition: '侧放',
    flatPosition: '躺放',
    uprightWithHorizontalRotation: '立放水平旋转',
    onSideWithHorizontalRotation: '侧放水平旋转',
    flatWithHorizontalRotation: '躺放水平旋转',
    permitted: '允许',
    mixedStackingAllowed: '上面放置别的种类货物',
    stackingTiers: '堆码层数',
    allowed: '是否允许',
    placementMethod: '摆放方式',
    tips: '说明：没有特殊限制以下选项可以为空，如有特殊限制请在对应摆放方式是否允许选项中选择否，上面放置别的种类货物选择不允许，堆码层数用数字填写允许的最大层数',
    no: '否',
    notAllowed: '不允许'
  },
  AccountHierarchySettings: {
    name: '名称',
    account: '账号',
    searchPlaceholder: '请输入员工名称、直接上级名称、跨级领导名称',
    employeeAccount: '员工账号',
    employeeName: '员工名称',
    email: '邮箱',
    directSuperiorAccount: '直接上级账号',
    directSuperiorName: '直接上级名称 ',
    directSuperiorEmail: '直接上级邮箱',
    skipLevelLeaderAccount: '跨级领导账号',
    skipLevelLeaderName: '跨级领导名称',
    skipLevelLeaderEmail: '跨级领导邮箱',
    isThereASkipLevelLeader: '是否有跨级领导',
    no: '无',
    yes: '有',
    dialogTitle: '{t}员工上下级关系'
  },
  ExReservationInvitationSummary:{
    title: '展会邀约汇总表',
    division: '事业部',
    totalNumberOfClients: '总客户数',
    plannedInvitationRate:'计划邀约率',
    plannedInvitationRateForCurrentExhibition: '本次展会计划邀约率',
    plannedNumberOfClientsToInvite: '计划邀约客户数',
    numberOfClientsDecliningAttendance: '不出席客户数',
    numberOfClientsInvited: '已邀约客户数',
    invitationAchievementRate: '邀约达成率',
    numberOfClients: '客户数',
    numberOfCollaboratedClients: '已合作客户数',
    numberOfNonCollaboratedClients: '未合作客户数',
    totalPlannedInvitations: '计划邀约总数',
    totalInvitationsCompleted: '已邀约总数',
    achievementRate: '达成率'
  },
  ToDoReminder: {
    marketsRelated: '展会相关',
    orderRelated: '竞品相关',
    competingProductsRelated: '订单相关',
    otherRelated: '其他'
  }
};
